import { render, staticRenderFns } from "./ForeignOffer.vue?vue&type=template&id=940c97be&scoped=true"
import script from "./ForeignOffer.vue?vue&type=script&lang=js"
export * from "./ForeignOffer.vue?vue&type=script&lang=js"
import style0 from "./ForeignOffer.vue?vue&type=style&index=0&id=940c97be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940c97be",
  null
  
)

export default component.exports